import { type FC } from 'react';

import { format } from 'date-fns';

import { BorderlessChip } from '@/src/components/atoms/chips/BorderlessChip';

import { RecoloredEventAvailableOutlined } from './RecoloredEventAvailableOutlined';

export interface UnlockDateChipProps {
  readonly unlockDate: Date | null;
}

/**
 * @deprecated
 */
export const UnlockDateChip: FC<UnlockDateChipProps> = ({ unlockDate }) => {
  if (!unlockDate) {
    return null;
  }

  const formattedDate = format(unlockDate, 'MMM. dd, yyyy');

  return (
    <BorderlessChip
      data-testid='unlock-date-chip'
      icon={<RecoloredEventAvailableOutlined />}
      label={formattedDate}
      size='small'
      variant='outlined'
    />
  );
};
